import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import { trackEvent } from 'dibs-tracking';
import { createFragmentContainer, graphql } from 'react-relay';

import ArrowLeft from 'dibs-vg/dist/react/arrow-left';
import ArrowRight from 'dibs-vg/dist/react/arrow-right';
import MessageBannerItem from './MessageBannerItem';
import { getMessagesToShow } from './messageHelpers';

import style from './MessageBanner-style.scss';

import {
    isPreview,
    wasShown,
    getTrackingObj,
    setValuesToStorage,
    addToShownList,
} from './messageHelpers';

class MessageBannerCarousel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messagesToShow: [],
            curr: 0,
        };

        this.handlePrevious = this.handlePrevious.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.fireTracking = this.fireTracking.bind(this);
    }

    componentDidMount() {
        const messagesToShow = this.props.showAllMessages
            ? this.props.messages
            : getMessagesToShow(this.props.messages);
        this.setState({ messagesToShow });
    }

    handlePrevious() {
        let index = this.state.curr - 1;

        if (index < 0) {
            index = this.state.messagesToShow.length - 1;
        }

        this.fireTracking(this.state.curr, 'previous', index);
        this.setState({ curr: index });
    }

    handleNext() {
        let index = this.state.curr + 1;

        if (index > this.state.messagesToShow.length - 1) {
            index = 0;
        }

        this.fireTracking(this.state.curr, 'next', index);
        this.setState({ curr: index });
    }

    fireTracking(previous, type, current) {
        if (!isPreview()) {
            trackEvent(
                getTrackingObj({
                    messageItem: this.state.messagesToShow[previous],
                    action: `banner ${type} clicked`,
                })
            );
        }
        this.setItemValuesToStorage(this.state.messagesToShow[current]);
    }

    setItemValuesToStorage(messageItem) {
        if (!isPreview() && !wasShown(messageItem)) {
            setValuesToStorage(messageItem);
            addToShownList(messageItem);

            trackEvent(
                getTrackingObj({
                    messageItem,
                    action: 'banner displayed',
                })
            );
        }
    }

    render() {
        const { isMultiLine } = this.props;
        const { curr, messagesToShow } = this.state;
        const count = messagesToShow.length;
        const hasPagination = count && count > 1;

        const carouselItemsStyle = {
            width: `${count * 100}%`,
            transform: `translateX(${-(curr / count) * 100}%)`,
        };

        const wrapperClasses = classnames({
            [style.carouselWrapper]: true,
            [style.hasPagination]: hasPagination,
        });

        this.setItemValuesToStorage(messagesToShow[0]);

        return (
            <div className={wrapperClasses}>
                {hasPagination ? (
                    <div className={style.carouselArrowWrapperLeft} onClick={this.handlePrevious}>
                        <ArrowLeft className={style.carouselArrowLeft} />
                    </div>
                ) : null}
                <div className={style.carousel}>
                    <div className={style.carouselItems} style={carouselItemsStyle}>
                        {messagesToShow.map(item => (
                            <MessageBannerItem
                                key={item.note.serviceId}
                                messageItem={item}
                                isMultiLine={isMultiLine}
                            />
                        ))}
                    </div>
                </div>
                {hasPagination ? (
                    <div className={style.carouselArrowWrapperRight} onClick={this.handleNext}>
                        <ArrowRight className={style.carouselArrowRight} />
                    </div>
                ) : null}
            </div>
        );
    }
}

MessageBannerCarousel.defaultProps = {
    isMultiLine: false,
};

MessageBannerCarousel.propTypes = {
    messages: PropTypes.array,
    showAllMessages: PropTypes.bool,
    isMultiLine: PropTypes.bool.isRequired,
};

export default (MessageBannerCarousel = createFragmentContainer(MessageBannerCarousel, {
    messages: graphql`
        fragment MessageBannerCarousel_messages on MessageSetModule @relay(plural: true) {
            userType
            items {
                impressionCap
                note {
                    serviceId
                    content {
                        title
                        message
                        cta {
                            text
                            url
                        }
                    }
                    anchors {
                        serviceId
                        content {
                            title
                            message
                            cta {
                                text
                                url
                            }
                        }
                    }
                }
            }
        }
    `,
}));
